import React from 'react';
import { tagTextColor } from '../../helpers/colors';

// Chip de etiqueta do CRM. Renderiza <button> quando recebe onClick (ex.: abrir
// edição) e <span> caso contrário. onRemove exibe um "×" para desvincular.
const TagChip = ({ name, color, className = 'tag-chip', onClick, onRemove, title }) => {
    const style = { backgroundColor: color, color: tagTextColor(color) };

    const content = (
        <>
            {name}
            {onRemove &&
                <button
                    type="button"
                    className="tag-chip__remove"
                    aria-label={`Remover etiqueta ${name}`}
                    onClick={e => {
                        e.stopPropagation();
                        onRemove();
                    }}
                >
                    ×
                </button>
            }
        </>
    );

    if (onClick) {
        return (
            <button type="button" className={className} style={style} onClick={onClick} title={title}>
                {content}
            </button>
        );
    }

    return (
        <span className={className} style={style} title={title}>
            {content}
        </span>
    );
};

export default TagChip;
